// src/pages/Navbar.js
import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import '../CSS/Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      const sections = [
        '#about',
        '#services',
        '#portfolio',
        '#tools',
        '#blogs',      // ✅ Added Blogs section
        '#contact'
      ];
      let found = '';
      for (const section of sections) {
        const elem = document.querySelector(section);
        if (elem) {
          const rect = elem.getBoundingClientRect();
          if (rect.top <= 80 && rect.bottom >= 80) {
            found = section;
            break;
          }
        }
      }
      if (found && found !== activeTab) {
        setActiveTab(found);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeTab]);

  const navLinks = [
    { href: '#about', label: 'About' },
    { href: '#services', label: 'Services' },
    { href: '#portfolio', label: 'Portfolio' },
    { href: '#tools', label: 'AI Tools' },
    { href: '#blogs', label: 'Blogs' }, // ✅ Added Blogs link
    { href: '#contact', label: 'Contact' }
  ];

const scrollToSection = (href) => {
  const element = document.querySelector(href);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
    setActiveTab(href);

    // ✅ Update the URL with the hash without reloading
    window.history.pushState(null, '', href);
  }
  setIsMobileMenuOpen(false);
};


  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => scrollToSection('#about')}>
          <div className="logo-circle">A</div>
          <span className="logo-text">aikanksha</span>
        </div>

        <ul className="navbar-links">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => scrollToSection(link.href)}
                className={`nav-link ${activeTab === link.href ? 'active' : ''}`}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="navbar-actions">
          <button
            aria-label="Toggle mobile menu"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <ul className="mobile-menu">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => scrollToSection(link.href)}
                className={`mobile-nav-link ${activeTab === link.href ? 'active' : ''}`}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
